import {Stack} from '@mui/material';
import {AlertInfo} from 'presentation/components/AlertInfo';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {SuccessAlertProps} from './types';

const {successAlert} = translations['pt-br'].privateFlow.profile.changeData;

const SuccessAlert = ({type}: SuccessAlertProps) => (
	<Stack>
		<AlertInfo.Root severity="success" icon={<Icon name="check-circle-outline-filled" />}>
			<AlertInfo.Title sx={{fontWeight: 600, mb: 0}} title={successAlert[type]} />
		</AlertInfo.Root>
	</Stack>
);

export {SuccessAlert};
